import { z } from 'zod';
import { ScheduleScope } from './invite.js';
/** "HH:MM" — what the UI works in. Home Assistant stores "HH:MM:SS". */
export const TimeOfDay = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);
/**
 * Two settings that look alike and are not. Keeping them apart matters: a
 * guest changing when their own room responds to motion is a private
 * preference; changing when the whole house dims is a decision about everyone.
 */
export const ScheduleKind = z.enum(['room_motion', 'house_night']);
export const ScheduleEntry = z.object({
    kind: ScheduleKind,
    /** Set for room_motion; null for house_night. */
    roomId: z.string().nullable(),
    roomName: z.string().nullable(),
    wake: TimeOfDay,
    bed: TimeOfDay,
    /** False while still following the usual times rather than the guest's. */
    overriding: z.boolean(),
    /** What a reset goes back to. */
    defaultWake: TimeOfDay,
    defaultBed: TimeOfDay,
});
export const ScheduleSettings = z.object({
    scope: ScheduleScope,
    entries: z.array(ScheduleEntry),
});
export const SetScheduleInput = z.object({
    kind: ScheduleKind,
    wake: TimeOfDay,
    bed: TimeOfDay,
});
export const ClearScheduleInput = z.object({ kind: ScheduleKind });
/** Admin editing the house's usual times. */
export const SetDefaultsInput = z.object({ wake: TimeOfDay, bed: TimeOfDay });
//# sourceMappingURL=schedule.js.map